module.exports = __webpack_public_path__ + "static/media/other.19bc4154.svg";